import { parseJournalBanners } from './parseJournalBanners';

const DAILYRENT_BANNER_MARKER = '<div data-name="dailyrent-banner"></div>';
const DAILYRENT_BANNER_MARKER_PATTERN = /<div[^>]*?data-name="dailyrent-banner"[^>]*?>\s*<\/div>/i;
const ADFOX_BANNER_PATTERN = /<div[^>]*?class="__adfox"[^>]*?>.*?<\/div>/is;

/**
 * Если редактор не поставил в статье маркер баннера посуточной аренды,
 * ставит маркер на место первого рекламного баннера в тексте (Adfox или баннера Журнала),
 * чтобы баннер посутки заменил его
 */
export const placeDailyrentBannerMarker = (html: string): string => {
  if (!html || DAILYRENT_BANNER_MARKER_PATTERN.test(html)) {
    return html;
  }

  const adfoxBanner = html.match(ADFOX_BANNER_PATTERN)?.[0];
  const journalBanner = parseJournalBanners(html).items[0]?.outerHtml;
  const banners = [adfoxBanner, journalBanner].filter((banner): banner is string => Boolean(banner));

  if (!banners.length) {
    return html;
  }

  const [firstBanner] = banners.sort((a, b) => html.indexOf(a) - html.indexOf(b));

  return html.replace(firstBanner, DAILYRENT_BANNER_MARKER);
};
